import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-nps-customer-survey.component.scss';
var FormItemNpsCustomerSurvey = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemNpsCustomerSurvey, _super);
    function FormItemNpsCustomerSurvey(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemNpsCustomerSurvey.prototype.init = function () {
        // form
        this.form = this.element.querySelector('form');
        this.nextStepButton1 = this.element.querySelector(".js_next-step-button1");
        this.nextStepButton2 = this.element.querySelector(".js_next-step-button2");
        this.wizard = this.element.querySelector('.form-container-wizard__wizard');
        this.wizardDisplay = this.element.querySelector('.form-container-wizard__counter');
        this.hasAccount = Array.from(this.element.querySelectorAll("input[name=hasStndBankAcc]"));
        this.achievedGoals = Array.from(this.element.querySelectorAll("input[name=achievedGoals]"));
        this.recommendRange = this.element.querySelector('input[name=recommendRange]');
        this.recommendRangeVal = this.element.querySelector('input[name=recommendRangeVal]').value;
        this.experienceRange = this.element.querySelector('input[name=experienceRange]');
        this.experienceRangeVal = this.element.querySelector('input[name=experienceRangeVal]').value;
        this.easyToFindRange = this.element.querySelector('input[name=easyToFindRange]');
        this.easyToFindRangeVal = this.element.querySelector('input[name=easyToFindRangeVal]').value;
        this.informationRange = this.element.querySelector('input[name=informationRange]');
        this.informationRangeVal = this.element.querySelector('input[name=informationRangeVal]').value;
        this.accessRange = this.element.querySelector('input[name=accessRange]');
        this.accessRangeVal = this.element.querySelector('input[name=accessRangeVal]').value;
        this.personalInfoRange = this.element.querySelector('input[name=personalInfoRange]');
        this.personalInfoRangeVal = this.element.querySelector('input[name=personalInfoRangeVal]').value;
        this.applyRange = this.element.querySelector('input[name=applyRange]');
        this.applyRangeVal = this.element.querySelector('input[name=applyRangeVal]').value;
        this.viewUseRange = this.element.querySelector('input[name=viewUseRange]');
        this.viewUseRangeVal = this.element.querySelector('input[name=viewUseRangeVal]').value;
        this.applyNotApplicableInput = this.element.querySelector('input[name=applyNotApplicable]');
        this.viewUseNotApplicableInput = this.element.querySelector('input[name=viewUseNotApplicable]');
        this.otherThoughtsInput = this.element.querySelector('textarea[name=otherThoughts]');
        this._hasAccountValue = "";
        this._achievedGoalsValue = "";
        // buttons
        this.submitBtn = Array.from(this.element.querySelectorAll('.js-npsSurvey__button--submit'));
    };
    FormItemNpsCustomerSurvey.prototype.bindEvents = function () {
        var _this = this;
        if (this.wizardDisplay) {
            this.wizardDisplay.classList.add("nps-customer-survey__wizardDisplayHide");
        }
        if (this.hasAccount) {
            this.hasAccount.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this._hasAccountValue = _radio.value;
                });
            });
        }
        if (this.achievedGoals) {
            this.achievedGoals.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this._achievedGoalsValue = _radio.value;
                });
            });
        }
        if (this.recommendRange) {
            this.recommendRange.addEventListener("input", function (event) {
                _this.recommendRangeVal = event.target.value;
            });
        }
        if (this.experienceRange) {
            this.experienceRange.addEventListener("input", function (event) {
                _this.experienceRangeVal = event.target.value;
            });
        }
        if (this.easyToFindRange) {
            this.easyToFindRange.addEventListener("input", function (event) {
                _this.easyToFindRangeVal = event.target.value;
            });
        }
        if (this.informationRange) {
            this.informationRange.addEventListener("input", function (event) {
                _this.informationRangeVal = event.target.value;
            });
        }
        if (this.accessRange) {
            this.accessRange.addEventListener("input", function (event) {
                _this.accessRangeVal = event.target.value;
            });
        }
        if (this.personalInfoRange) {
            this.personalInfoRange.addEventListener("input", function (event) {
                _this.personalInfoRangeVal = event.target.value;
            });
        }
        if (this.applyRange) {
            this.applyRange.addEventListener("input", function (event) {
                _this.applyRangeVal = event.target.value;
            });
        }
        if (this.viewUseRange) {
            this.viewUseRange.addEventListener("input", function (event) {
                _this.viewUseRangeVal = event.target.value;
            });
        }
        if (this.applyNotApplicableInput) {
            var _applyNotApplicableInput_1 = this.applyNotApplicableInput;
            var _applyRange_1 = this.applyRange;
            var _applyRangeVal_1 = this.applyRangeVal;
            this.applyNotApplicableInput.addEventListener('change', function () {
                if (_applyNotApplicableInput_1.checked) {
                    _applyRange_1.value = 0;
                    _applyRangeVal_1 = 0;
                    _applyRange_1.disabled = true;
                }
                else {
                    _applyRange_1.disabled = false;
                }
            });
        }
        if (this.viewUseNotApplicableInput) {
            var _viewUseNotApplicableInput_1 = this.viewUseNotApplicableInput;
            var _viewUseRange_1 = this.viewUseRange;
            var _viewUseRangeVal_1 = this.viewUseRangeVal;
            this.viewUseNotApplicableInput.addEventListener('change', function () {
                if (_viewUseNotApplicableInput_1.checked) {
                    _viewUseRange_1.value = 0;
                    _viewUseRangeVal_1 = 0;
                    _viewUseRange_1.disabled = true;
                }
                else {
                    _viewUseRange_1.disabled = false;
                }
            });
        }
        if (this.nextStepButton2) {
            this.nextStepButton2.addEventListener("click", function (event) {
                _this.clearErrors();
                var isValid = _this.radioButtonsValidation();
                if (!isValid) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
            });
        }
        this.submitBtn.map(function (item) { return item.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                // screens
                var loader = _form.querySelector(".form__loader--container");
                var fieldsContainer = _form.querySelector(".form__fields--container");
                // loader + hide form
                loader.classList.add("active");
                fieldsContainer.classList.add("hidden");
                fieldsContainer.classList.remove('active');
                // Check if gRecaptcha is enabled for this form
                if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                    var gToken_1 = '';
                    try {
                        // Attempt to get recaptcha token
                        grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var err_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                    case 1:
                                        gToken_1 = _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        // Log error
                                        console.log("Unable to retrieve gRecaptcha Token");
                                        console.log(err_1);
                                        return [3 /*break*/, 3];
                                    case 3:
                                        // Set recaptcha token
                                        this.gRecaptchaToken = gToken_1;
                                        this.submitForm(_form);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    catch (err) {
                        // Log error
                        console.log("Unable to retrieve gRecaptcha Token");
                        console.log(err);
                        _this.submitForm(_form);
                    }
                }
                else {
                    _this.submitForm(_form);
                }
            }
        }); });
        // if (this.form) {
        // 	const _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
        // 	if (_formFields) {
        // 		_formFields.forEach(pElement => {
        // 			pElement.addEventListener('blur', (pEvent) => {
        // 				this.validationService.validateBlur(pEvent.currentTarget as any);
        // 			});
        // 		});
        // 	}
        // }
        // Reset the form
        this.form.addEventListener('custom_form_reset_event', function (e) {
            if (_this.wizard) {
                var event_1 = new CustomEvent('custom_wizard_reset_event');
                _this.wizard.dispatchEvent(event_1);
            }
        }, false);
    };
    FormItemNpsCustomerSurvey.prototype.clearErrors = function () {
        var selectionArray = [];
        // Radio Details Selection Error
        var hasAccountRadioGroup = this.hasAccount[0].closest(".form__group");
        selectionArray.push(hasAccountRadioGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        var selectionArray2 = [];
        // Radio Details Selection Error
        var achievedGoalsRadioGroup = this.achievedGoals[0].closest(".form__group");
        selectionArray2.push(achievedGoalsRadioGroup);
        // Clear errors
        selectionArray2.forEach(function (groupItem) {
            groupItem.classList.remove("form__group--error");
            var errorMessage = groupItem.querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
    };
    FormItemNpsCustomerSurvey.prototype.radioButtonsValidation = function () {
        var isValid = true;
        var radioErrorDetails = "This field is required";
        // Radio Details Selection Error Check
        var hasAccountGroup = this.hasAccount[0].closest(".form__group");
        if (!hasAccountGroup.classList.contains("form__group--hidden")) {
            if (this._hasAccountValue === "") {
                isValid = false;
                hasAccountGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                hasAccountGroup.appendChild(_errorDiv);
            }
        }
        // Radio Details Selection Error Check
        var achievedGoalsGroup = this.achievedGoals[0].closest(".form__group");
        if (!achievedGoalsGroup.classList.contains("form__group--hidden")) {
            if (this._achievedGoalsValue === "") {
                isValid = false;
                achievedGoalsGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                achievedGoalsGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemNpsCustomerSurvey.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        // additional containers
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        // loader + hide form
        loader.classList.add('active');
        // variables
        var analyticsService = new AnalyticsService();
        var url = '/leadsutils/createnpscs';
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var _postData = {
            sbsaCustomer: this._hasAccountValue,
            achieveEverythingOnWebsite: this._achievedGoalsValue,
            recommendSBSARating: this.recommendRangeVal,
            overallExperienceRating: this.experienceRangeVal,
            easyToFindIamLookingFor: this.easyToFindRangeVal,
            informationIsClearAndHelpFul: this.informationRangeVal,
            accessWebsiteWithConsistentOrDowntime: this.accessRangeVal,
            feelSafeToShareMyPersonalInfo: this.personalInfoRangeVal,
            easyToApplyForProductsOrRequestServices: this.applyNotApplicableInput.checked ? 0 : this.applyRangeVal,
            easyToViewAndUseWebsiteOnMobile: this.viewUseNotApplicableInput.checked ? 0 : this.viewUseRangeVal,
            otherOpenFeedback: this.otherThoughtsInput.value,
            productPage: window.location.href,
        };
        // service
        this.formsService.postForm(url, _postData, config).then(function (response) {
            loader.classList.remove('active');
            if (response.data == null || String(response.data).match(/invalid/gi) || String(response.data).match(/503/gi)) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                thankYou.classList.add('active');
                error.classList.remove('hidden');
                error.classList.add('active');
                success.classList.remove('active');
                success.classList.add('hidden');
            }
            else {
                analyticsService.dtmFormComplete('complete', response.code);
                thankYou.classList.add('active');
                error.classList.remove('active');
                error.classList.add('hidden');
                success.classList.remove('hidden');
                success.classList.add('active');
                var isSurveyCompleted = 'true';
                localStorage.setItem(_this.surveyExpiryInfoService.getSurveyCompleteName(), isSurveyCompleted);
                _this.surveyExpiryInfoService.setTimeExpired();
            }
            // reset form values
            _this.resetForm();
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            thankYou.classList.add('active');
            error.classList.remove('hidden');
            error.classList.add('active');
            success.classList.remove('active');
            success.classList.add('hidden');
            // reset form values
            _this.resetForm();
        });
    };
    FormItemNpsCustomerSurvey.prototype.resetForm = function () {
        this.applyRange.disabled = false;
        this.viewUseRange.disabled = false;
        this.applyNotApplicableInput.checked = false;
        this.viewUseNotApplicableInput.checked = false;
        this._hasAccountValue = "";
        this._achievedGoalsValue = "";
        this.recommendRangeVal = "1";
        this.experienceRangeVal = "1";
        this.easyToFindRangeVal = "1";
        this.informationRangeVal = "1";
        this.accessRangeVal = "1";
        this.personalInfoRangeVal = "1";
        this.applyRangeVal = "1";
        this.viewUseRangeVal = "1";
        this.otherThoughtsInput.value = "";
    };
    return FormItemNpsCustomerSurvey;
}(Base));
export { FormItemNpsCustomerSurvey };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-nps-customer-survey/form-item-nps-customer-survey.component.ts
// module id = 950
// module chunks = 0